export default [
  {
    name: 'cfg-template-create',
    path: '/units/template/create',
    component: () => import('@/views/units/CfgTemplateManage')
  },
  {
    name: 'cfg-template-edit',
    path: '/units/template/:id/edit',
    component: () => import('@/views/units/CfgTemplateManage')
  },
  {
    name: 'cfg-template-view',
    path: '/units/template/:id/view',
    component: () => import('@/views/units/CfgTemplateManage')
  },
  {
    name: 'cfg-template-find',
    path: '/units/template/find',
    component: () => import('@/views/units/CfgTemplateFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeCfgTemplates.js